import { useDashboard } from "@/context/dashboard";
import Cookies from "js-cookie";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function SideBar({ isTicketView }) {
  const router = useRouter();
  const [selectedKey, setSelectedKey] = useState(0);
  const [appLink, setAppLink] = useState();
  const { loggedUserDetails, setLoggedUserDetails } = useDashboard();

  useEffect(() => {
    setAppLink(getAppLink());
  }, []);

  const getAppLink = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      return "https://play.google.com/store/apps/details?id=com.qoncertapp.artist";
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else if (/Macintosh|Mac OS X/.test(userAgent)) {
      return "https://apps.apple.com/us/app/qoncert-live-shows/id1537042846";
    } else {
      return "https://www.qoncertapp.com/";
    }
  };

  const logout = async () => {
    try {
      let web_token = loggedUserDetails?.data?.web_token;
      const formData = new FormData();
      formData.append("action", "logout");

      const response = await fetch(
        `${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageUserData`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${web_token}`,
          },
          body: formData,
        }
      );

      const data = await response.json();

      if (data.status) {
        localStorage.clear();
        Cookies.remove("user_data");
        setLoggedUserDetails({
          status: false,
          data: "",
          remove: true,
        });
        window.location.href = "/"
      } else {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/";
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (isTicketView) {
    return null;
  }
  useEffect(() => {
    const path = router.pathname;
    if (path.includes("dashboard") || path.includes("tickets")) {
      setSelectedKey(0);
    } else if (path.includes("profile")) {
      setSelectedKey(1);
    } else if(path.includes("orders")) {
      setSelectedKey(2);
    } else {
      setSelectedKey(-1);
    }
  }, [router.pathname]);

  return (
    <div
      id="SideBar"
      className="w-[240px] flex flex-col h-full pb-11 bg-[#141414]"
    >
      <Link href={"/"} className="p-5 pl-9">
        <img src={"/assets/logo.webp"} alt="" />
      </Link>
      <div className="mt-10 ">
        <div className="flex flex-wrap flex-col gap-8">
          <div
            onClick={() => router.push("/dashboard")}
            className={`flex gap-4 py-3 items-start hover:bg-[#1F222A] rounded-[6px]  justify-center cursor-pointer ${selectedKey == 0 ? "bg-[#1F222A]" : ""
              }`}
          >
            <div>
              <svg
                width="28"
                height="28"
                viewBox="0 0 28 28"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.5864 4.2002V7.29799"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.5864 20.4683V23.0584"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  d="M15.5864 16.9679V10.7979"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M25.0837 16.3923C21.9445 16.3923 21.9445 11.6069 25.0837 11.6069C25.0837 6.06242 25.0837 4.0835 14.0003 4.0835C2.91699 4.0835 2.91699 6.06242 2.91699 11.6069C6.05619 11.6069 6.05619 16.3923 2.91699 16.3923C2.91699 21.9379 2.91699 23.9168 14.0003 23.9168C25.0837 23.9168 25.0837 21.9379 25.0837 16.3923Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="me-16 dashboard-link">Tickets</div>
          </div>
          <div
            onClick={() => router.push("/orders")}
            className={`flex gap-6 py-3 items-start hover:bg-[#1F222A] rounded-[6px] justify-center cursor-pointer ${selectedKey == 2 ? "bg-[#1F222A]" : ""}`}
          >
            <div>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M21.419 15.7321C21.419 19.3101 19.31 21.4191 15.732 21.4191H7.95C4.363 21.4191 2.25 19.3101 2.25 15.7321V7.93209C2.25 4.35909 3.564 2.25009 7.143 2.25009H9.143C9.861 2.25109 10.537 2.58809 10.967 3.16309L11.88 4.37709C12.312 4.95109 12.988 5.28909 13.706 5.29009H16.536C20.123 5.29009 21.447 7.11609 21.447 10.7671L21.419 15.7321Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M7.4812 14.463H16.2162" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="me-16 dashboard-link">Orders</div>
          </div>
          <div
            onClick={() => router.push("/shows")}
            className="flex gap-6 py-3 items-start hover:bg-[#1F222A] rounded-[6px] justify-center cursor-pointer"
          >
            <div>
              <svg
                width="24"
                height="25"
                viewBox="0 0 24 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M19 11.5833C19 15.5143 15.866 18.701 12 18.701M12 18.701C8.13401 18.701 5 15.5143 5 11.5833M12 18.701V22.7683M12 22.7683H8M12 22.7683H16M12 14.6338C10.3431 14.6338 9 13.268 9 11.5833V5.48235C9 3.79763 10.3431 2.43188 12 2.43188C13.6569 2.43188 15 3.79763 15 5.48235V11.5833C15 13.268 13.6569 14.6338 12 14.6338Z"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="me-16 dashboard-link">Shows</div>
          </div>
          <div
            onClick={() => router.push("/profile")}
            className={`flex gap-6 py-3 items-start hover:bg-[#1F222A] rounded-[6px] justify-center cursor-pointer ${selectedKey == 1 ? "bg-[#1F222A]" : ""
              }`}
          >
            <div>
              <svg
                width="24"
                height="26"
                viewBox="0 0 24 26"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.9849 16.365C8.11731 16.365 4.81445 16.9596 4.81445 19.3409C4.81445 21.7222 8.09636 22.3381 11.9849 22.3381C15.8525 22.3381 19.1545 21.7425 19.1545 19.3622C19.1545 16.9819 15.8735 16.365 11.9849 16.365Z"
                  stroke="white"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M11.9849 12.9686C14.523 12.9686 16.5801 10.8759 16.5801 8.2951C16.5801 5.71431 14.523 3.62256 11.9849 3.62256C9.44679 3.62256 7.3887 5.71431 7.3887 8.2951C7.38013 10.8672 9.42394 12.9599 11.9525 12.9686H11.9849Z"
                  stroke="white"
                  strokeWidth="1.42857"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <div className="me-16 dashboard-link">Profile</div>
          </div>
          <div className="mt-14 flex justify-center">
            <a href={appLink} target="_blank">
              <svg
                width="179"
                height="50"
                viewBox="0 0 179 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="0.5"
                  width="178"
                  height="49"
                  rx="15.5"
                  fill="white"
                />
                <rect
                  x="0.5"
                  y="0.5"
                  width="178"
                  height="49"
                  rx="15.5"
                  stroke="#111928"
                />
                <path
                  d="M40.159 23.1406C40.0695 22.8295 39.9438 22.5547 39.7819 22.3161C39.6199 22.0732 39.4218 21.8686 39.1874 21.7024C38.9573 21.532 38.6931 21.402 38.3948 21.3125C38.1008 21.223 37.7748 21.1783 37.4168 21.1783C36.7478 21.1783 36.1597 21.3445 35.6526 21.6768C35.1498 22.0092 34.7577 22.4929 34.4765 23.1278C34.1952 23.7585 34.0546 24.5298 34.0546 25.4418C34.0546 26.3537 34.1931 27.1293 34.4701 27.7685C34.7471 28.4077 35.1391 28.8956 35.6462 29.2322C36.1533 29.5646 36.752 29.7308 37.4424 29.7308C38.0688 29.7308 38.6036 29.62 39.0468 29.3984C39.4942 29.1726 39.8351 28.8551 40.0695 28.446C40.3082 28.0369 40.4275 27.5533 40.4275 26.995L40.99 27.0781H37.615V24.9943H43.093V26.6435C43.093 27.794 42.8501 28.7827 42.3643 29.6094C41.8785 30.4318 41.2094 31.0668 40.3572 31.5142C39.5049 31.9574 38.529 32.179 37.4296 32.179C36.2023 32.179 35.1242 31.9084 34.1952 31.3672C33.2662 30.8217 32.5418 30.0483 32.0219 29.0469C31.5063 28.0412 31.2485 26.848 31.2485 25.4673C31.2485 24.4062 31.4019 23.4602 31.7087 22.6293C32.0198 21.794 32.4545 21.0866 33.0127 20.5071C33.5709 19.9276 34.2208 19.4865 34.9623 19.1839C35.7037 18.8814 36.507 18.7301 37.3721 18.7301C38.1135 18.7301 38.8039 18.8388 39.4431 19.0561C40.0823 19.2692 40.6491 19.5717 41.1434 19.9638C41.642 20.3558 42.0489 20.8224 42.3643 21.3636C42.6796 21.9006 42.882 22.4929 42.9715 23.1406H40.159ZM45.172 32V18.9091H53.993V21.1911H47.9397V24.3104H53.5392V26.5923H47.9397V29.718H54.0186V32H45.172ZM55.6949 21.1911V18.9091H66.4463V21.1911H62.4385V32H59.7027V21.1911H55.6949ZM71.8843 21.1911V18.9091H82.6357V21.1911H78.6279V32H75.8921V21.1911H71.8843ZM84.4063 32V18.9091H87.1741V24.3104H92.7927V18.9091H95.5541V32H92.7927V26.5923H87.1741V32H84.4063ZM97.836 32V18.9091H106.657V21.1911H100.604V24.3104H106.203V26.5923H100.604V29.718H106.683V32H97.836ZM115.28 32H112.314L116.833 18.9091H120.4L124.913 32H121.947L118.668 21.9006H118.565L115.28 32ZM115.095 26.8544H122.1V29.0149H115.095V26.8544ZM126.488 32V18.9091H131.653C132.646 18.9091 133.492 19.0987 134.191 19.478C134.89 19.853 135.422 20.375 135.789 21.044C136.16 21.7088 136.345 22.4759 136.345 23.3452C136.345 24.2145 136.157 24.9815 135.782 25.6463C135.407 26.3111 134.864 26.8288 134.152 27.1996C133.445 27.5703 132.589 27.7557 131.583 27.7557H128.291V25.5376H131.135C131.668 25.5376 132.107 25.446 132.452 25.2628C132.802 25.0753 133.062 24.8175 133.232 24.4893C133.407 24.157 133.494 23.7756 133.494 23.3452C133.494 22.9105 133.407 22.5312 133.232 22.2074C133.062 21.8793 132.802 21.6257 132.452 21.4467C132.103 21.2635 131.66 21.1719 131.123 21.1719H129.256V32H126.488ZM138.143 32V18.9091H143.307C144.3 18.9091 145.146 19.0987 145.845 19.478C146.544 19.853 147.077 20.375 147.443 21.044C147.814 21.7088 147.999 22.4759 147.999 23.3452C147.999 24.2145 147.812 24.9815 147.437 25.6463C147.062 26.3111 146.518 26.8288 145.807 27.1996C145.099 27.5703 144.243 27.7557 143.237 27.7557H139.945V25.5376H142.79C143.322 25.5376 143.761 25.446 144.106 25.2628C144.456 25.0753 144.716 24.8175 144.886 24.4893C145.061 24.157 145.148 23.7756 145.148 23.3452C145.148 22.9105 145.061 22.5312 144.886 22.2074C144.716 21.8793 144.456 21.6257 144.106 21.4467C143.757 21.2635 143.314 21.1719 142.777 21.1719H140.91V32H138.143Z"
                  fill="black"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
      <div className="flex-grow"></div>
      <div className="flex gap-4 py-3 items-start hover:bg-[#1F222A] rounded-[6px]  justify-center cursor-pointer">
        <div>
          <svg
            width="24"
            height="26"
            viewBox="0 0 24 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M3.50004 15.0563C3.50004 15.4669 3.16404 15.8001 2.75012 15.8001C2.3362 15.8001 2.00019 15.4669 2.00019 15.0563V7.70006C2.00019 5.33717 3.93831 3.41479 6.32151 3.41479H11.0675C13.4555 3.41479 15.3985 5.342 15.3985 7.71069V8.61005C15.3985 9.01964 15.0625 9.35292 14.6486 9.35292C14.2347 9.35292 13.8987 9.01964 13.8987 8.61005V7.71069C13.8987 6.16119 12.6287 4.90247 11.0675 4.90247H6.32151C4.76517 4.90247 3.50004 6.15829 3.50004 7.70006V15.0563ZM13.8985 17.5401C13.8985 17.1296 14.2345 16.7963 14.6484 16.7963C15.0623 16.7963 15.3983 17.1296 15.3983 17.5401V18.4492C15.3983 20.812 13.4602 22.7344 11.077 22.7344H6.33008C3.94298 22.7344 2 20.8072 2 18.4385C2 18.028 2.336 17.6957 2.74992 17.6957C3.16384 17.6957 3.49985 18.028 3.49985 18.4385C3.49985 19.988 4.76985 21.2467 6.33008 21.2467H11.077C12.6333 21.2467 13.8985 19.9919 13.8985 18.4492V17.5401ZM21.9433 12.7908C21.8274 12.5116 21.5537 12.33 21.2499 12.33H9.5491C9.13518 12.33 8.7982 12.6642 8.7982 13.0748C8.7982 13.4854 9.13518 13.8186 9.5491 13.8186H19.4345L17.8752 15.3585C17.5811 15.6483 17.5811 16.1187 17.8732 16.4105C18.0193 16.5563 18.2122 16.6298 18.404 16.6298C18.5959 16.6298 18.7868 16.5563 18.9339 16.4124L21.7797 13.6022C21.9939 13.3897 22.0592 13.069 21.9433 12.7908ZM19.1218 11.7128C18.9309 11.7128 18.74 11.6404 18.594 11.4974L17.8762 10.7932C17.582 10.5043 17.5801 10.0329 17.8713 9.74213C18.1635 9.44846 18.6368 9.44653 18.9319 9.73633L19.6487 10.4396C19.9438 10.7294 19.9458 11.1999 19.6546 11.4916C19.5075 11.6384 19.3147 11.7128 19.1218 11.7128Z"
              fill="white"
            />
          </svg>
        </div>
        <div
          onClick={() => {
            logout();
          }}
          className="me-16 dashboard-link"
        >
          Sign out
        </div>
      </div>
    </div>
  );
}
